export default "__VITE_ASSET__CDGyFgSr__"